import { createRouter, createWebHashHistory } from 'vue-router'
import { getLocale, loadLocaleMessages, setI18nLanguage, SUPPORT_LOCALES } from '../i18n'
import routesRecord, { routeNames, quizzSteps } from './routes'
export { routeNames, quizzSteps }
import type { I18n } from 'vue-i18n'
import type { Router, RouteRecordRaw } from 'vue-router'

export default function setupRouter(i18n: I18n): Router {
  const locale = getLocale(i18n)

  // setup routes
  const routes: RouteRecordRaw[] = routesRecord(locale)

  // create router instance
  const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }
      if (to.path !== from.path) return { left: 0, top: 0, behavior: "smooth" };
    },
  })

  // navigation guards
  router.beforeResolve(async (to) => {
    const paramsLocale = to.params.locale as string
    // load locale messages
    if (!i18n.global.availableLocales.includes(paramsLocale)) {
      await loadLocaleMessages(i18n, paramsLocale)
    }

    // set i18n language
    setI18nLanguage(i18n, paramsLocale)
  })


  return router
}
